import { AttachedImage, Flex, Image } from '@/components';
import type { CSSProperties, FC } from 'react';
import type { z } from 'zod';

import type { AttachmentsModel } from '../_models/attachment';
import { AttachmentNameWithOpenButton } from './AttachmentNameWithOpenButton';

type Props = {
  attachments: z.infer<typeof AttachmentsModel>;
  alt?: string;
  showIndex?: boolean;
  columnStyle?: CSSProperties;
  imageWrapperStyle?: CSSProperties;
};

export const AttachedImageGroup: FC<Props> = ({
  attachments = [],
  alt,
  showIndex,
  columnStyle,
  imageWrapperStyle,
}) => {
  return (
    <Image.PreviewGroup>
      {attachments.map(
        (image, idx) =>
          image.url && (
            <Flex key={image.id} vertical style={columnStyle}>
              <AttachedImage
                order={showIndex ? idx + 1 : undefined}
                src={image.url}
                alt={alt ?? image.fileName}
                wrapperStyle={imageWrapperStyle}
                style={{ objectPosition: 'unset' }}
                showPreview
              />
              <AttachmentNameWithOpenButton
                name={image.fileName}
                src={image.url}
              />
            </Flex>
          ),
      )}
    </Image.PreviewGroup>
  );
};
